import React from "react";
import { useAppState } from "../../contexts/UserContext";
import { useAuth } from "../../contexts/AuthContext";
import { useStripeSubscriptionStatus } from "../settings/hooks/useStripeSubscriptionStatus";
import { SubscriptionList } from "./components/SubscriptionList";
import { SuccessDisplay } from "./components/SuccessDisplay";
import { SubscribeMessage } from "./components/SubscribeMessage";
import { useSubscribeCatalog } from "./hooks/useSubscribeCatalog";
import { useSubscribeCheckoutReturn } from "./hooks/useSubscribeCheckoutReturn";
import { SubscriptionStatus } from "./components/SubscriptionStatus";
import styles from "./components/Subscribe.module.css";
import ButtonsSection from "../../components/ui/buttons/ButtonsSection";

export default function SubscriptionManager() {
  const { refreshData } = useAppState();
  const { userId, email } = useAuth();
  const {
    hasStripeSubscription,
    currentPeriodEnd,
    cancelAt,
    activePriceId,
    isLoading: isStripeStatusLoading,
    refetch: refetchStripeStatus,
  } = useStripeSubscriptionStatus(userId);

  const {
    catalogProducts,
    isLoading: catalogLoading,
    error: catalogError,
  } = useSubscribeCatalog();
  const { message, success, sessionId } = useSubscribeCheckoutReturn({
    userId,
    email,
    refetchStripeStatus,
    refreshData,
  });

  if (!success && message === "") {
    return (
      <>
        <div className={styles.titleRow}>
          <span className="page-title">Subscriptions Now</span>
        </div>
        <SubscriptionStatus
          catalogProducts={catalogProducts}
          hasActiveStripe={hasStripeSubscription}
          stripeStatusLoading={isStripeStatusLoading}
          currentPeriodEnd={currentPeriodEnd}
          activePriceId={activePriceId}
          cancelAt={cancelAt}
        />
        <SubscriptionList
          uid={userId}
          catalogProducts={catalogProducts}
          catalogLoading={catalogLoading}
          catalogError={catalogError}
          currentPeriodEnd={currentPeriodEnd}
          activePriceId={activePriceId}
          cancelAt={cancelAt}
        />
        <ButtonsSection />
      </>
    );
  }
  if (success && sessionId !== "") {
    return <SuccessDisplay sessionId={sessionId} userId={userId} />;
  }
  return <SubscribeMessage message={message} />;
}
